<div class="card border-0" style="background-color: #b2d0dc" *transloco="let t; read: 'ime.components.dashboard'">
  <div class="card-body">
    <h4 class="card-title pb-3 d-flex justify-content-between">
      <span>
        <svg viewBox="0 0 8 8" class="icon me-1" [inlineSVG]="'#users'">
        </svg>
        {{t('Activity Stream')}}
      </span>
      <span ngbDropdown [autoClose]="'outside'">
        <a class="ms-auto mb-n2 text-primary dropdown-toggle-without-arrow" ngbDropdownToggle role="button"aria-haspopup="true" aria-expanded="false">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bars-3"></svg>
        </a>
        <div ngbDropdownMenu>
          <button type="button" ngbDropdownItem class="dropdown-item" *ngFor="let type of selectableTypes" (click)="toggleType(type.id)">
            <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1 text-success" inlineSVG="#check" *ngIf="selectedTypes.includes(type.id)">
            </svg>
            {{type.name}}
          </button>
          <div class="dropdown-divider"></div>
          <button type="button" ngbDropdownItem class="dropdown-item" (click)="toggleOnlyByMe()">
            <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1 text-success" inlineSVG="#check" *ngIf="showOnlyByMe">
            </svg>
            {{t('Only by me')}}
          </button>
        </div>
      </span>
    </h4>
    <ul class="list-group list-group-flush">
      <li class="list-group-item d-flex justify-content-between" *ngFor="let item of lastActivities$ | async">
        <span *ngLet="(usersQuery.getAll$ | async | find: 'Id': item.ModifiedBy) as user">
          <strong>{{user?.Fullname || user?.Email}}</strong> {{t('modified')}} {{(selectableTypes | find: 'id': item.Type)?.name}}
          <a class="text-break" href="{{item.Url}}">{{item | displayName}}</a>
          <span class="text-muted ms-2">{{item.ModifiedDate | date: 'short'}}</span>
        </span>
      </li>
    </ul>
  </div>
</div>
